module.exports = __webpack_public_path__ + "static/media/marquiseshape.1000fde0.jpg";